import React, { useState } from "react";
import { CardElement, useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { Button, Option, PaymentHeader, SelectWrapper, StepContent, StepIndicator } from "./styles";
import { PaymentContainer } from "./styles";
import { Heading } from "./styles";
import { CardInputWrapper } from "./styles";
import { config } from "../../config";
import { toast } from "react-toastify";
import CardInput from "../CardInput";
import BoletoInput from "../BoletoInput";
import PurchaseSummary from "../PurchaseSummary";
import { useHistory } from "react-router-dom";

const PaymentStep = ({ clientSecret, clientEmail, clientName, itens, clientCpf }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentMethod, setPaymentMethod] = useState("card"); // "card" ou "boleto"
    const [isLoading, setIsLoading] = useState(false);
    const [billingDetails, setBillingDetails] = useState({
        line1: "",
        city: "",
        state: "",
        postal_code: "",
        country: "BR",
        cpf: "",
    });

    const history = useHistory();

    const handlePayment = async () => {
        if (!stripe || !elements) {
            toast.error("O Stripe ainda está carregando.");
            return;
        }

        setIsLoading(true);

        try {
            let result;

            if (paymentMethod === "card") {
                const cardElement = elements.getElement("card");
                result = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: clientName,
                            email: clientEmail,
                        },
                    },
                    return_url: config.PAYMENT_SUCCESS_PAGE,
                });
            } else if (paymentMethod === "boleto") {
                result = await stripe.confirmBoletoPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            address: {
                                line1: billingDetails.line1,
                                city: billingDetails.city,
                                state: billingDetails.state,
                                postal_code: billingDetails.postal_code,
                                country: billingDetails.country,
                            },
                            name: clientName,
                            email: clientEmail,
                        },
                        boleto: {
                            tax_id: billingDetails.cpf,
                        },
                    },
                    return_url: config.PAYMENT_SUCCESS_PAGE,
                });
            }

            if (result.error) {
                toast.error(result.error.message || "Erro ao processar o pagamento.");
            } else if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
                toast.success("Pagamento confirmado! Estamos processando sua inscrição.");
                history.push(`/status?cpf=${clientCpf}`);
            } else {
                toast.warn("O pagamento está pendente ou falhou. Tente novamente.");
            }
        } catch (error) {
            console.log(error);
            toast.error("Erro inesperado ao processar pagamento.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <PaymentContainer>
            <StepContent>
                <h3>Escolha o Método de Pagamento</h3>
                <SelectWrapper>
                    <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                        <option value="card">Cartão de Crédito</option>
                        <option value="boleto">Boleto Bancário</option>
                    </select>
                </SelectWrapper>
                {paymentMethod === "card" && <CardInput />}
                {paymentMethod === "boleto" && (
                    <BoletoInput billingDetails={billingDetails} setBillingDetails={setBillingDetails} />
                )}
                <Button onClick={handlePayment} disabled={isLoading}>
                    {isLoading ? "Processando..." : "Pagar"}
                </Button>
            </StepContent>
            <PurchaseSummary itens={itens} />
        </PaymentContainer>
    );
};

export default PaymentStep;
